import { ShoppingBag, Hourglass } from "lucide-react";

const duracion = (dias) => {
  if (dias == null) return null;
  if (dias < 1) return "menos de 1 día";
  if (dias < 14) return `≈ ${Math.round(dias)} día${Math.round(dias) === 1 ? "" : "s"}`;
  if (dias < 60) return `≈ ${Math.round(dias / 7)} semanas`;
  return `≈ ${(dias / 30).toFixed(dias < 90 ? 1 : 0)} meses`;
};

/** Para productos bajo el mínimo o sin stock: cuánto dura el stock y cuánto pedir (mismo criterio que el Panel de bajo stock). */
export default function ReordenHint({ producto, disponible, coberturaDias = 60 }) {
  const ritmo = Number(producto?.stock_minimo_auto_info?.ritmo_dia || 0);
  const minimo = Number(producto?.stock_minimo || 0);
  const stock = Math.max(0, Number(disponible ?? producto?.stock_actual ?? 0));
  const dias = ritmo > 0 ? stock / ritmo : null;
  const pedir = ritmo > 0 ? Math.ceil(ritmo * coberturaDias) : Math.max(0, minimo - stock);
  if (!pedir && dias == null) return null;
  return (
    <div className="mt-0.5 text-[10px] leading-tight text-muted-foreground tabular-nums" data-testid={`reorden-hint-${producto.id}`}>
      {dias != null ? (
        <div className={`inline-flex items-center gap-1 ${dias <= 7 ? "text-rose-600" : dias <= 30 ? "text-amber-700" : ""}`} title={`Vende ≈ ${ritmo.toFixed(1)} und/día (últimos ${producto.stock_minimo_auto_info?.dias_analisis || 60} días)`}>
          <Hourglass className="w-3 h-3" /> Te dura {stock <= 0 ? "— sin stock" : duracion(dias)}
        </div>
      ) : (
        <div className="inline-flex items-center gap-1" title="No hay ventas en el período analizado; el pedido sugerido es para volver al mínimo">
          <Hourglass className="w-3 h-3" /> Sin ventas en {producto.stock_minimo_auto_info?.dias_analisis || 60} días
        </div>
      )}
      {pedir > 0 && (
        <div className="inline-flex items-center gap-1 text-primary font-semibold ml-2" title={ritmo > 0 ? `Vende/día × ${coberturaDias} días de cobertura` : "Para volver al mínimo"}>
          <ShoppingBag className="w-3 h-3" /> Pedir ≈ {pedir.toLocaleString("es-CO")}
        </div>
      )}
    </div>
  );
}
